import { Button } from "primereact/button";
import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
// import BrushIcon from "../../assets/icon/brush.svg"
// import { Outlet } from "react-router-dom";

export default function DashboardLayout({ children }) {
  const location = useLocation();
  return (
    <>
      <div className="menu bg-gray ">
        <div className="container">
          <div className="flex dashboard-menu overflow-auto md:grid gap-4 p-3">
            <Link to="home" >
              <Button
                label="Home"
                icon="pi pi-home"
                className={`border-none ${
                  location.pathname === "/dashboard/home"
                    ? "bg-red"
                    : "bg-white text-black-alpha-90"
                }`}
              />
            </Link>

            <Link to="my-orders" >
              <Button
                label="My Orders"
                icon="pi pi-shopping-bag"
                className={`border-none ${
                  location.pathname === "/dashboard/my-orders"
                    ? "bg-red"
                    : "bg-white text-black-alpha-90"
                }`}
              />
            </Link>

            <Link to="services" >
              <Button
                label="Services"
                icon="pi pi-cog"
                className={`border-none ${
                  location.pathname === "/dashboard/services"
                    ? "bg-red"
                    : "bg-white text-black-alpha-90"
                }`}
              />
            </Link>

            <Link to="style-guide" >
              <Button
                label="Style Guide"
                icon="pi pi-pencil"
                className={`border-none ${
                  location.pathname === "/dashboard/style-guide"
                    ? "bg-red"
                    : "bg-white text-black-alpha-90"
                }`}
              />
            </Link>

            <Link to="profile" >
              <Button
                label="Profile"
                icon="pi pi-user"
                className={`border-none ${
                  location.pathname === "/dashboard/profile"
                    ? "bg-red"
                    : "bg-white text-black-alpha-90"
                }`}
              />
            </Link>
            <Link to="stagesmart" >
              <Button
                label="Stagesmart"
                icon="pi pi-comment"
                className={`border-none ${
                  location.pathname === "/dashboard/stagesmart"
                    ? "bg-red"
                    : "bg-white text-black-alpha-90"
                }`}
              />
            </Link>
          </div>
        </div>
      </div>
      <Outlet />
    </>
  );
}
